import { Routes } from '@angular/router';
import { permissionGuard } from '../../core/auth/permission.guard';

const adminScope = { requiredScopes: ['admin'] as const };

export const COMMS_REDIRECT_ROUTES: Routes = [
  { path: 'call-center', redirectTo: 'comms/control-center', pathMatch: 'full' },
  { path: 'call-center/queues', redirectTo: 'comms/queues', pathMatch: 'full' },
  { path: 'call-center/interactions', redirectTo: 'comms/interactions', pathMatch: 'full' },
  { path: 'call-center/callbacks', redirectTo: 'comms/queues', pathMatch: 'full' }
];

export const COMMS_ROUTES: Routes = [
  {
    path: 'comms/control-center',
    loadComponent: () => import('./comms-control-center.component').then(m => m.CommsControlCenterComponent),
    canActivate: [permissionGuard],
    data: { requiredPermission: 'comms.agent.view', ...adminScope }
  },
  {
    path: 'comms/telephony',
    loadComponent: () => import('./comms-telephony.component').then(m => m.CommsTelephonyComponent),
    canActivate: [permissionGuard],
    data: { requiredPermission: 'comms.telephony.view', ...adminScope }
  },
  {
    path: 'comms/numbers',
    loadComponent: () => import('./comms-numbers.component').then(m => m.CommsNumbersComponent),
    canActivate: [permissionGuard],
    data: { requiredPermission: 'comms.numbers.view', ...adminScope }
  },
  {
    path: 'comms/carrier-profiles',
    loadComponent: () => import('./comms-carrier-profiles.component').then(m => m.CommsCarrierProfilesComponent),
    canActivate: [permissionGuard],
    data: { requiredPermission: 'comms.usage.view', ...adminScope }
  },
  {
    path: 'comms/provisioning-orders',
    loadComponent: () => import('./comms-provisioning-orders.component').then(m => m.CommsProvisioningOrdersComponent),
    canActivate: [permissionGuard],
    data: { requiredPermission: 'comms.provisioning.view', ...adminScope }
  },
  {
    path: 'comms/provisioning-orders/:orderId',
    loadComponent: () => import('./comms-provisioning-order-detail.component').then(m => m.CommsProvisioningOrderDetailComponent),
    canActivate: [permissionGuard],
    data: { requiredPermission: 'comms.provisioning.view', ...adminScope }
  },
  {
    path: 'comms/extensions',
    loadComponent: () => import('./comms-extensions.component').then(m => m.CommsExtensionsComponent),
    canActivate: [permissionGuard],
    data: { requiredPermission: 'comms.extensions.view', ...adminScope }
  },
  {
    path: 'comms/agent-presence',
    loadComponent: () => import('./comms-agent-presence.component').then(m => m.CommsAgentPresenceComponent),
    canActivate: [permissionGuard],
    data: { requiredPermission: 'comms.agent.view', ...adminScope }
  },
  {
    path: 'comms/queues',
    loadComponent: () => import('./comms-queues.component').then(m => m.CommsQueuesComponent),
    canActivate: [permissionGuard],
    data: { requiredPermission: 'comms.queues.view', ...adminScope }
  },
  {
    path: 'comms/queues/:queueId',
    loadComponent: () => import('./comms-queue-detail.component').then(m => m.CommsQueueDetailComponent),
    canActivate: [permissionGuard],
    data: { requiredPermission: 'comms.queues.view', ...adminScope }
  },
  {
    path: 'comms/routing-rules',
    loadComponent: () => import('./comms-routing-rules.component').then(m => m.CommsRoutingRulesComponent),
    canActivate: [permissionGuard],
    data: { requiredPermission: 'comms.routing.view', ...adminScope }
  },
  {
    path: 'comms/ivr-flows',
    loadComponent: () => import('./comms-ivr-flows.component').then(m => m.CommsIvrFlowsComponent),
    canActivate: [permissionGuard],
    data: { requiredPermission: 'comms.ivr.view', ...adminScope }
  },
  {
    path: 'comms/ivr-flows/:ivrFlowId',
    loadComponent: () => import('./comms-ivr-designer.component').then(m => m.CommsIvrDesignerComponent),
    canActivate: [permissionGuard],
    data: { requiredPermission: 'comms.ivr.view', ...adminScope }
  },
  {
    path: 'comms/interactions',
    loadComponent: () => import('./comms-interactions.component').then(m => m.CommsInteractionsComponent),
    canActivate: [permissionGuard],
    data: { requiredPermission: 'comms.interactions.view', ...adminScope }
  },
  {
    path: 'comms/interactions/:interactionId',
    loadComponent: () => import('./comms-interaction-detail.component').then(m => m.CommsInteractionDetailComponent),
    canActivate: [permissionGuard],
    data: { requiredPermission: 'comms.interactions.view', ...adminScope }
  },
  {
    path: 'comms/usage-billing',
    loadComponent: () => import('./comms-usage-billing.component').then(m => m.CommsUsageBillingComponent),
    canActivate: [permissionGuard],
    data: { requiredPermission: 'comms.usage.view', ...adminScope }
  },
  {
    path: 'comms/voice-sessions/:voiceSessionId',
    loadComponent: () => import('./comms-voice-session-detail.component').then(m => m.CommsVoiceSessionDetailComponent),
    canActivate: [permissionGuard],
    data: { requiredPermission: 'comms.voice-ai.view', ...adminScope }
  },
  {
    path: 'comms/voice-sessions/by-interaction/:interactionId',
    loadComponent: () => import('./comms-voice-session-detail.component').then(m => m.CommsVoiceSessionDetailComponent),
    canActivate: [permissionGuard],
    data: { requiredPermission: 'comms.voice-ai.view', ...adminScope }
  },
  {
    path: 'comms/recovery-cases/:recoveryCaseId',
    loadComponent: () => import('./comms-recovery-case-detail.component').then(m => m.CommsRecoveryCaseDetailComponent),
    canActivate: [permissionGuard],
    data: { requiredPermission: 'comms.recovery.view', ...adminScope }
  },
  {
    path: 'comms/recovery-cases/by-interaction/:interactionId',
    loadComponent: () => import('./comms-recovery-case-detail.component').then(m => m.CommsRecoveryCaseDetailComponent),
    canActivate: [permissionGuard],
    data: { requiredPermission: 'comms.recovery.view', ...adminScope }
  },
  {
    path: 'comms/qa',
    loadComponent: () => import('./comms-qa.component').then(m => m.CommsQaComponent),
    canActivate: [permissionGuard],
    data: { requiredPermission: 'comms.qa.view', ...adminScope }
  },
  {
    path: 'comms/analytics',
    loadComponent: () => import('./comms-analytics.component').then(m => m.CommsAnalyticsComponent),
    canActivate: [permissionGuard],
    data: { requiredPermission: 'comms.analytics.view', ...adminScope }
  },
  {
    path: 'comms/program-readiness',
    loadComponent: () => import('./comms-program-readiness.component').then(m => m.CommsProgramReadinessComponent),
    canActivate: [permissionGuard],
    data: { requiredPermission: 'comms.operations.view', ...adminScope }
  },
  {
    path: 'comms/agent-workspace',
    loadComponent: () => import('./comms-agent-workspace.component').then(m => m.CommsAgentWorkspaceComponent),
    canActivate: [permissionGuard],
    data: { requiredPermission: 'comms.agent.execute', ...adminScope }
  }
];
